export enum ModalType {
  Cancellation = 'CANCELLATION',
  CannotRescheduleGroup = 'CANNOT_RESCHEDULE_GROUP',
}

export type ModalContext = {
  type: ModalType;
  props: any;
};
